import * as BrokerActionTypes from '../actions/brokers';
import initialState from './initialState';

import { errorResponseHandler } from '../utils/error-utils';

export default (state = initialState.brokers, action) => {
  const { payload, type } = action;

  switch (type) {
    case BrokerActionTypes.LIST_BROKERS:
    case BrokerActionTypes.LIST_BROKERS_PENDING:
      return { ...state, brokers_loading: true };

    case BrokerActionTypes.LIST_BROKERS_REJECTED:
      return {
        ...state,
        brokers_loading: true,
        ...errorResponseHandler(payload, 'BrokersList')
      };

    case BrokerActionTypes.LIST_BROKERS_FULFILLED:
      return { ...state, brokers_loading: false, brokers: payload.data };

    case BrokerActionTypes.LIST_FILTERED_BROKERS:
    case BrokerActionTypes.LIST_FILTERED_BROKERS_PENDING:
      return { ...state, loadingFilteredBrokers: true ,filteredBrokers: []};
    case BrokerActionTypes.LIST_FILTERED_BROKERS_REJECTED:
      return {
        ...state,
        loadingFilteredBrokers: false,
        ...errorResponseHandler(payload, 'FilteredBrokers')
      };
    case BrokerActionTypes.LIST_FILTERED_BROKERS_FULFILLED:
      return {
        ...state,
        loadingFilteredBrokers: false,
        filteredBrokers: payload.data,
      };
    case BrokerActionTypes.LIST_INTERMEDIARIES:
    case BrokerActionTypes.LIST_INTERMEDIARIES_PENDING:
      return { ...state, intermediaries_loading: true };

    case BrokerActionTypes.LIST_INTERMEDIARIES_REJECTED:
      return {
        ...state,
        intermediaries_loading: true,
        ...errorResponseHandler(payload, 'IntermediaryList')
      };

    case BrokerActionTypes.LIST_INTERMEDIARIES_FULFILLED:
      return {
        ...state,
        intermediaries_loading: false,
        intermediaries: payload.data
      };

    case BrokerActionTypes.LIST_BANK_AGENCIES:
    case BrokerActionTypes.LIST_BANK_AGENCIES_PENDING:
      return { ...state, bank_agencies_loading: true };

    case BrokerActionTypes.LIST_BANK_AGENCIES_REJECTED:
      return {
        ...state,
        bank_agencies_loading: true,
        ...errorResponseHandler(payload, 'BankAgencyList')
      };

    case BrokerActionTypes.LIST_BANK_AGENCIES_FULFILLED:
      return {
        ...state,
        bank_agencies_loading: false,
        bank_agencies: payload.data
      };

    case BrokerActionTypes.LIST_BROKER_ADMINS:
    case BrokerActionTypes.LIST_BROKER_ADMINS_PENDING:
      return { ...state, broker_admins_loading: true };

    case BrokerActionTypes.LIST_BROKER_ADMINS_REJECTED:
      return {
        ...state,
        broker_admins_loading: false,
        ...errorResponseHandler(payload, 'BrokerAdminsList')
      };

    case BrokerActionTypes.LIST_BROKER_ADMINS_FULFILLED:
      return { ...state, broker_admins: payload.data };

    case BrokerActionTypes.LIST_PARTNERS:
    case BrokerActionTypes.LIST_PARTNERS_PENDING:
      return { ...state, partnersLoading: true };

    case BrokerActionTypes.LIST_PARTNERS_REJECTED:
      return {
        ...state,
        partnersLoading: false,
        ...errorResponseHandler(payload, 'PartnersList')
      };

    case BrokerActionTypes.LIST_PARTNERS_FULFILLED:
      return { ...state, partnersLoading: false, partners: payload.data };

    case BrokerActionTypes.LIST_AGENCIES:
    case BrokerActionTypes.LIST_AGENCIES_PENDING:
      return { ...state, agenciesLoading: true };

    case BrokerActionTypes.LIST_AGENCIES_REJECTED:
      return {
        ...state,
        agenciesLoading: false,
        ...errorResponseHandler(payload, 'AgenciesList')
      };

    case BrokerActionTypes.LIST_AGENCIES_FULFILLED:
      return { ...state, agenciesLoading: false, agencies: payload.data };

    case BrokerActionTypes.CREATE_BROKER_PENDING:
      return { ...state, isRegistering: true };

    case BrokerActionTypes.CREATE_BROKER_REJECTED:
      return {
        ...state,
        isRegistering: false,
        ...errorResponseHandler(payload, 'CreateBroker')
      };

    case BrokerActionTypes.CREATE_BROKER_FULFILLED:
      let createdBroker = payload.data;
      return Object.assign({}, state, {
        brokers: [createdBroker, ...state.brokers],
        success: true,
        isRegistering: false,
        successMessage: payload.statusText
      });
    //return { ...state, isRegistering: false, error: false, success: true, successMessage: payload.data }

    case BrokerActionTypes.CREATE_ADMIN_PENDING:
      return { ...state, isRegistering: true };

    case BrokerActionTypes.CREATE_ADMIN_REJECTED:
      return {
        ...state,
        isRegistering: false,
        ...errorResponseHandler(payload, 'CreateBrokerAdmin')
      };

    case BrokerActionTypes.CREATE_ADMIN_FULFILLED:
      return {
        ...state,
        isRegistering: false,
        error: false,
        success: true,
        successMessage: payload.data
      };

    case BrokerActionTypes.CREATE_BROKER_PARTNER_PENDING:
      return { ...state, isRegistering: true };

    case BrokerActionTypes.CREATE_BROKER_PARTNER_REJECTED:
      return {
        ...state,
        isRegistering: false,
        ...errorResponseHandler(payload, 'CreateBrokerPartner')
      };

    case BrokerActionTypes.CREATE_BROKER_PARTNER_FULFILLED:
      let createdPartner = payload.data;
      return Object.assign({}, state, {
        partners: [createdPartner, ...state.partners],
        success: true,
        isRegistering: false,
        successMessage: payload.statusText
      });
    // return { ...state, isRegistering: false, error: false, successPartners: true, successMessage: payload.data }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/brokers.js